var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"request-steps"},[_c('PerfectScrollbar',{ref:"requestStepsRef",attrs:{"options":_vm.options}},[_c('ul',{staticClass:"steps-container"},_vm._l((_vm.value),function(item,index){return _c('li',{key:item.id,class:[
					'step-item',
					{
						'step-item-short': _vm.isShort,
						'step-item--active': _vm.activeId == item.id && !item.color,
						'step-item-blink': item.status == _vm.$constant.REQUEST_STATUSES.WAITING && _vm.checkUpdatedAt(),
					}
				],style:(_vm.getCustomStyle(item, index)),on:{"click":function($event){$event.preventDefault();return _vm.handleClick(item)}}},[_c('span',{staticClass:"step-item__name"},[_vm._v(_vm._s(!_vm.isShort ? item.name : _vm.shortName(item.name, index)))])])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }